export default __webpack_public_path__ + "static/media/contact-new.75dacf64.png";